<template>
  <div v-if="!isPC" class="bg-white tutorial">
    <div class="tutorial-category" v-for="(item,index) in categoryList" :key="index">
      <div class="tutorial-className">{{item.className}}</div>
      <div class="tutorial-title pointer" v-for="(e,i) in item.essayList" :key="i" @click="toTutorialDetail(e)">{{e.title}}</div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      categoryList: [],
      listForm: {
        pageNumber: 1,
        pageSize: 10000,
        labelName: `${this.$t('Home.helpCenter.MobileTutorialList.Tutorial')}`
      }
    }
  },
  created() {
    this.listForm.classificationId = Number(this.$route.params.id)
    this.getEssayById()
  },
  methods: {
    getEssayById() {
      API.getEssayById(this.listForm).then(res => {
        this.categoryList = res.data
      })
    },
    toTutorialDetail(e) {
      console.log(e)
      this.$router.push({
        path: '/tutorial-detail',
        query: {
          content: JSON.stringify(e)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tutorial {
  padding: 1rem 0.32rem 0.5rem;
  min-height: 100vh;
}
.tutorial-category {
  padding-top: 0.4rem;
  .tutorial-className {
    font-weight: 400;
    font-size: 0.32rem;
    line-height: 0.48rem;
    color: #000000;
  }
  .tutorial-title {
    font-weight: 400;
    font-size: 0.32rem;
    line-height: 0.7rem;
    color: #7b7b7b;
    padding-left: 0.4rem;
  }
}
</style>
